import { render, staticRenderFns } from "./TaskButton.vue?vue&type=template&id=cf4c0158"
import script from "./TaskButton.vue?vue&type=script&lang=js"
export * from "./TaskButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports